import axios from 'axios';

const API_BASE_URL = 'https://api.xiaomimiart.com';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
          url: API_BASE_URL + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    // let text = "";
    // let a = 0;
    // for (const key in params) {
      
      
    //   if(a==0){
    //     text =text+ key+"="+params[key]
    //   }else{
    //     text =text+ "&"+key+"="+params[key]
    //   }
    //   a++;
    // }
    return axios({
        method: method,

        
      url: API_BASE_URL + url + "?" + "&token=" + localStorage.getItem('logintoken'),



        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }

                return ret
            }
        ]
    }).then(res => res.data);
};

const reqJson = (method, url, params) => {
    const token = localStorage.getItem('logintoken')
    return axios({
        method: method,
        url: API_BASE_URL + url + "?" + "&token=" + token,
        headers: {
            'Content-Type': 'application/json',
            token: token
        },
        data: Object.assign({}, params || {}, {
            token: token
        })
    }).then(res => res.data);
};

export {
    loginreq,
    req,
    reqJson
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js